(function (_) {
    'use strict';

    _['PRODUCTS.CATALOG.TOCART.PRECONFIRM'] = 'Adicionar';
    _['PRODUCTS.CATALOG.TOCART.CONFIRM'] = 'Adicionar';
    _['PRODUCTS.PRODUCT.TOCART.CONFIRM'] = 'Adicionar ao carrinho';
    _['PRODUCTS.CATEGORY'] = 'Categoria';
    _['PRODUCTS.PRICE'] = 'Preço';
    _['PRODUCTS.TAGS'] = 'Etiquetas';
    _['PRODUCTS.FEATURES'] = 'Cuidados';
    _['PRODUCTS.BRAND'] = 'Marca';

    _['PRODUCTS.FILTERS'] = 'Filtros';
    _['PRODUCTS.FILTERS.FILTER'] = 'Filtrar';
    _['PRODUCTS.FILTERS.DELETE'] = 'Remover filtros';
    _['PRODUCTS.FILTERS.NAME.LABEL'] = 'Nome';
    _['PRODUCTS.FILTERS.NAME.PLACEHOLDER'] = 'Buscar por palavras...';
    _['PRODUCTS.FILTERS.CATEGORY.LABEL'] = 'Categoria';
    _['PRODUCTS.FILTERS.CATEGORY.DEFAULT'] = 'Buscar por categoria...';
    _['PRODUCTS.FILTERS.SUBCATEGORY.LABEL'] = 'Subcategoria';
    _['PRODUCTS.FILTERS.SUBCATEGORY.DEFAULT'] = 'Buscar por subcategoria...';
    _['PRODUCTS.FILTERS.PRICE.LABEL'] = 'Ordenar por';
    _['PRODUCTS.FILTERS.PRICE.DEFAULT'] = 'Ordenar por';
    _['PRODUCTS.FILTERS.PRICE.ASC'] = 'Preço do menor para maior';
    _['PRODUCTS.FILTERS.PRICE.DESC'] = 'Preço do maior para o menor';

    _['PRODUCTS.PRODUCT.SIZE'] = 'Tamanho';
    _['PRODUCTS.PRODUCT.COLOR'] = 'Cor';
    _['PRODUCTS.PRODUCT.NOSTOCK'] = 'Fora de stock!';
    _['PRODUCTS.PRODUCT.NOSTOCKATORDER'] = 'Tu acabas de exceder o stock máximo permitido deste produto.';
    _['PRODUCTS.PRODUCT.TOOMUCHAMOUNT'] = 'Demasiado!';
    _['PRODUCTS.PRODUCT.AMOUNT'] = 'Quantidade';

}(translations['pt']));





// WEBPACK FOOTER //
// ./src/app/plugins/products/lang/products-lang_pt.js